import { Box, styled } from '@mui/material';
import DESIGN_COLORS from 'shared/_ui/design-colors';

export const SubsectionContainer = styled(Box, { name: 'SubsectionContainer' })(({ theme }) => ({
	marginBottom: theme.spacing(4.5),
}));

export const SubsectionHeader = styled(Box, { name: 'SubsectionHeader' })(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: theme.spacing(3),
	marginBottom: theme.spacing(0.5),
	padding: theme.spacing(2, 1),
	borderBottom: `1px solid ${DESIGN_COLORS.border}`,
}));

export const SubsectionLabel = styled('h3', { name: 'SubsectionLabel' })(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(2),
	minWidth: 0,
	margin: 0,
	color: DESIGN_COLORS.muted,
	fontFamily: theme.typography.fontFamily,
	fontSize: '0.8125rem',
	fontWeight: 700,
	letterSpacing: '0.025rem',
	textTransform: 'uppercase',
	'& > .MuiSvgIcon-root': {
		flexShrink: 0,
		fontSize: '0.9375rem',
		color: DESIGN_COLORS.faint,
	},
}));

export const CountBadge = styled('span', { name: 'CountBadge' })(({ theme }) => ({
	padding: theme.spacing(0.25, 1.75),
	borderRadius: '0.5625rem',
	backgroundColor: DESIGN_COLORS.borderSoft,
	color: DESIGN_COLORS.muted,
	fontSize: '0.6875rem',
	letterSpacing: 'normal',
	textTransform: 'none',
}));

export const SubsectionActions = styled(Box, { name: 'SubsectionActions' })(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(0.5),
}));

export const ToolDivider = styled('span', { name: 'ToolDivider' })(({ theme }) => ({
	flexShrink: 0,
	width: 1,
	height: '1rem',
	margin: theme.spacing(0, 1),
	backgroundColor: DESIGN_COLORS.border,
}));

export const FilesList = styled(Box, { name: 'FilesList' })(({ theme }) => ({
	borderRadius: theme.spacing(2.5),
	backgroundColor: theme.palette.background.paper,
}));

